import 'bootstrap';

jQuery( function( $ ) {

    //Header offset
    function on_resize(){
        // Set header offset css var
        // Use the toggler as reference size.
        var header = document.getElementsByClassName('navbar')[0];
        var offset = header.getBoundingClientRect().bottom;
        var height = header.clientHeight;
        document.documentElement.style.setProperty('--header-offset', offset + "px");
        document.documentElement.style.setProperty('--header-height', height + "px");
    }
    on_resize();
    window.addEventListener('resize', on_resize, true);

    // Make sure that header search and nav cant be open at the same time.
    $('#header-search').on('show.bs.collapse', function(){
        $('#header-nav').collapse('hide');
        $('.offcanvas-collapse').removeClass('open');
    });

    $('#header-search').on('shown.bs.collapse', function(){
        var searchInputField = $(this).find('.search-field').get(0)
        searchInputField.focus();
    });

    $('#header-search').on('hide.bs.collapse', function(){
        var searchInputField = $(this).find('.search-field').get(0)
        searchInputField.blur();
    });

    $('#header-nav').on('show.bs.collapse', function(){
        $('#header-search').collapse('hide');
    });

    // Offcanvas
    $('[data-toggle="offcanvas"]').on('click', function () {
        var $el = $('.offcanvas-collapse');

        // This makes the body non-scrollable while remaining scroll position
        if( $el.hasClass('open') ){
            $el.removeClass('open');
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
            $el.addClass('open');
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.position = 'fixed';
        }
    });

    // Add loaded class for media-text element
    var mediaTextImages = document.querySelectorAll(".wp-block-media-text img");
    mediaTextImages.forEach( item => { 
        item.addEventListener("load", addLoadClass);
        item.addEventListener("ecLoad", addLoadClass);

        // Item is already loaded :o good job caching.
        // Lets dispatch an ecLoad event. 
        if(item.complete) {
            var event = document.createEvent('Event');
            event.initEvent('ecLoad', true, true);
            item.dispatchEvent(event);
        }
    });

    function addLoadClass( e ) {
        var block = e.path.find( function( el ){
            return el.classList.contains('wp-block-media-text');
        });

        if( block ){
            window.setTimeout( function(){
                block.classList.add('loaded');
            }, 100);
        }
    }

    /**
     * Trigger hover effects on images while hovering over card link
     */
     $('.card').on('mouseenter mouseleave', '.card-body a, .card-link', function(e) {
        var link = e.target.href;
        var $imageLink = $(e.delegateTarget).find('.card-img-left a').first();

        if( $imageLink.attr('href') == link) {
            $imageLink.toggleClass('hover');
        }
    });


    /**
     * Pardot Iframe Listener
     */
    window.addEventListener("message", (event) => {

        /**
         * Report brand and text color classes to pardot iFrame
         */
        if(event.data == 'pardotFormLoaded'){
            var brandColorClass, textColorClass = '';

            var iframe = getFrameByEvent(event);
            var brandColorParent = $(iframe).closest("[class*='brand-color-']")[0];
            if( brandColorParent ){
                brandColorClass = (brandColorParent.className.match(/(^|\s)(brand\-color\-[^\s]*)/) || [,,''])[2];
            }

            var textColorParent = $(iframe).closest(".has-text-color")[0];
            if( textColorParent ) {
                textColorClass = (textColorParent.className.match(/(^|\s)(has\-[^\s]*\-color)/) || [,,''])[2];
            }

            event.source.postMessage({ brandColorClass, textColorClass }, '*');
        }

        if(event.data.pardotFormHeight){
            var iframe = getFrameByEvent(event);
            $(iframe).height( event.data.pardotFormHeight );
        }
    }, false);

    function getFrameByEvent(event) {
        return [].slice.call(document.getElementsByTagName('iframe')).filter(function(iframe) {
          return iframe.contentWindow === event.source;
        })[0];
    }


    // Submenu toggle
    $('.dropdown-menu .dropdown').on('show.bs.dropdown', toggle_parent_dropdown);
    $('.dropdown-menu .dropdown').on('hidden.bs.dropdown', toggle_parent_dropdown);
    
    function toggle_parent_dropdown( e, data ){
        $(this).parents('.dropdown-menu').each( function() {
            $(this).siblings('.dropdown-toggle').dropdown('show');
        }); 
    }

    $('.dropdown-menu .dropdown').on('shown.bs.dropdown', function( e ){
        // make sure it fits
        const rect = $(e.target).children('.dropdown-menu')[0].getBoundingClientRect();
        const fitsRight = rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        if(!fitsRight){
            $(e.target).addClass('dropdown-left');
        } else {
            $(e.target).removeClass('dropdown-left');
        }
    });
});

